import { css } from "@styled-system/css";
import { grid } from "@styled-system/patterns";

export const inputWrapperClass = grid({
	gridTemplateColumns: "[minmax(0,1fr) 4rem]",
});

export const helpIconClass = css({
	cursor: "help",
	display: "flex",
	justifyContent: "center",
});

export const helpTextClass = css({
	maxWidth: "[24rem]",
	display: "flex",
	flexDirection: "column",
	gap: "8",
});

export const helpListClass = css({
	listStyleType: "disc",
	paddingLeft: "16",
});

export const videoDisplayWrapper = css({
	py: "16",
});

export const previewVideoClass = css({
	maxWidth: "full",
});

export const errorTextClass = css({
	color: "error.100",
});

export const warningTextClass = css({
	display: "block",
	color: "warning.100",
});
